exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.pre-loader[data-v-6a94e976] {\n    background-color: rgb(255, 255, 255, 0.4);\n    z-index: 1;\n}\n", "", {"version":3,"sources":["/Users/soslanbolotaev/project/brunch_system-crm/src/components/src/components/Preloader.vue"],"names":[],"mappings":";AAaA;IACA,0CAAA;IACA,WAAA;CACA","file":"Preloader.vue","sourcesContent":["<template>\n    <div class=\"w-100 h-100 position-absolute pre-loader d-flex justify-content-center align-items-center\">\n        <b-spinner class=\"mr-2\" type=\"border\" variant=\"dark\" small></b-spinner>\n    </div>\n</template>\n\n<script>\nexport default {\n  name: 'Preloader'\n}\n</script>\n\n<style scoped>\n    .pre-loader {\n        background-color: rgb(255, 255, 255, 0.4);\n        z-index: 1;\n    }\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a94e976","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Preloader.vue
// module id = WqDW
// module chunks = 1